import React from 'react';
import PropTypes from 'prop-types';
import Chartist from 'chartist';
import ChartistGraph from 'react-chartist';
import 'chartist-plugin-tooltips';
import { formatMoney } from 'accounting';
import { DateTime } from 'luxon';
import 'chartist/dist/chartist.min.css';
import './DashboardTimelineChart.css';

const DashboardTimelineChart = (props) => {
  return (
    <ChartistGraph
      data={props.data}
      options={{
        showArea: true,
        axisY: {
          labelInterpolationFnc: v => formatMoney(v, '$', 0),
          offset: 75,
        },
        axisX: {
          type: Chartist.FixedScaleAxis,
          divisor: 6,
          labelInterpolationFnc: (v) => {
            return DateTime.fromMillis(v).toLocaleString();
          },
        },
        plugins: [
          Chartist.plugins.tooltip({
            anchorToPoint: true,
            tooltipFnc: (meta, v) => {
              const [date, value] = v.split(',');
              return `${DateTime.fromMillis(parseInt(date, 10)).toLocaleString(DateTime.DATE_MED)}: ${formatMoney(value)}`;
            },
          }),
        ],
      }}
      type="Line"
      className="ct-major-twelfth"
    />
  );
};

DashboardTimelineChart.propTypes = {
  data: PropTypes.shape({
    series: PropTypes.array.isRequired,
  }).isRequired,
};

export default DashboardTimelineChart;



// WEBPACK FOOTER //
// ./src/components/pages/dashboard/DashboardTimelineChart.jsx